<div class="modal-header bg-light">
  <h4 class="modal-title" class="text-center"><b>Productos</b></h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()">
    
  </button>
</div>

<div class="modal-body">
<table *ngIf="this.productos!=null && this.productos.length > 0" class="table table-striped table-hover">
  <thead>
    <td class="text-center"><b>Código</b></td>
    <td class="text-center"><b>Nombre</b></td>
  </thead>
  <tbody>
    <tr *ngFor="let p of productos; let i = index">
      <td class="text-center">{{  p.codigoProducto }}</td>
      <td class="text-center"> {{p.nombreProducto}}</td>
   </tr>
  </tbody>
</table>
</div>





